import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import ProgressionImg from "../assets/progresion.png";
import WorkoutImg from "../assets/workout.png";
import NutritionImg from "../assets/nutritions.png";
import Background2 from "../assets/background2.jpg";




const cardList = [
  {
    img: ProgressionImg,
    title: "Progression",
    description:
      "Our team of experts will work with you to create a customized plan that helps you achieve success one step at a time.",
  },
  {
    img: WorkoutImg,
    title: "Workout",
    description:
      " With a variety of workouts to choose from, you'll have everything you need to get into the best shape of your life.",
  },
  {
    img: NutritionImg,
    title: "Nutritions",
    description:
      "Our team will work with you to create a personalized meal plan that helps you reach your specific health goals.",
  },
];

function Home() {
  return (
    <div className="home">
      <img src="background.jpg" alt="Gym Background" className="background-image" />
      
      <div className="content">
        <h1 className="main-title">Find Your Energy</h1>
        <h2 className="subtitle">Make your Body Fit & Perfect</h2>
        <Link to="/classes" className="cta-button">Our Classes</Link>
      </div>
      
      <section className="features" style={{backgroundImage: `url(${Background2})`}}>
        {cardList.map((card, index) => (
          <div key={index} className="feature">
            <img src={card.img} alt={card.title} />
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </div>
        ))}
      </section>

      <section className="gym-timings" style={{backgroundImage: `url(${Background2})`}}>
        <h2 className="timings-title">Gym Opening Timings</h2>
        <table className="timings-table">
          <thead>
            <tr>
              <th>Shift</th>
              <th>Timings</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Morning</td>
              <td>6:00 AM - 10:00 AM</td>
            </tr>
            <tr>
              <td>Evening</td>
              <td>3:00 PM - 9:00 PM</td>
            </tr>
          </tbody>
        </table>
      </section>
      
    </div>
  );
}

export default Home;
